/* eslint-disable max-len, react/jsx-max-depth, react/no-array-index-key, capitalized-comments */
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// import faqs from "./faqs";
import { useUser } from "../UserContext";

// Import the quotes.svg as a react component
import { ReactComponent as QuotesIcon } from "../../assets/icons/quotes.svg";

import Loader from "../../components/Loader";
import TransactionHistoryCard from "./Dashboard/TransactionHistoryCard";
import { pageContent } from "../services/eqqo.page.content";
import { useQuery } from "react-query";

const ProfileCompleteDashboard = () => {
	const { eqqoOptions, user } = useUser();
	const {
		data: dashboardContent,
		isLoading
	} = pageContent( eqqoOptions?.dashboard_content, useQuery, { enabled: !!eqqoOptions?.dashboard_content })

	return isLoading
		? <Loader />
		: (
			<div className="profile__dashboard">
				<Row>
					<Col md={6}>
						<Container className="bg-white border h-100 rounded-3">
							<h2>Access your EQQO</h2>
							<Button
								as={Link}
								className="mt-4 w-100"
								to="/report/introduction"
							>
								View Your EQQO Profile Report
							</Button>
							{
								user?.eqqoProfile?.reportInstructionsConfirmed
									? (
										<Button
											as={Link}
											className="mt-1 w-100"
											to="/report/print"
											variant="secondary"
										>
											Download/Print Your EQQO Profile Report
										</Button>
									)
									: null
							}
						</Container>
					</Col>
					<Col md={6}>
						<TransactionHistoryCard />
					</Col>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card body className="bg-white">
							<div dangerouslySetInnerHTML={{ __html: dashboardContent?.acf?.introduction || "" }} />

							<Card body className="bg-eqqo-light-gray border-0">
								<div className="position-relative">
									<Image className="mb-3" src={dashboardContent?.acf?.debrief?.bg_image} width="910" />
									<div className="testimonial-container h-100 p-3 d-flex">
										<div className="bg-eqqo-light-gray opacity-75 w-100 rounded-3 p-3">
											<QuotesIcon className="mb-2" />
											<div className="banner-testimonial" dangerouslySetInnerHTML={{ __html: dashboardContent?.acf?.debrief?.testimonial?.content || "" }} />
											<div className="d-flex align-items-center">
												<Image className="rounded-circle" height="52" src={dashboardContent?.acf?.debrief?.testimonial?.image || "http://placehold.co/52x52"} width="52" />
												<div className="ms-2">
													<p className="fw-b mb-0" dangerouslySetInnerHTML={{ __html: dashboardContent?.acf?.debrief?.testimonial?.name || "" }} />
												</div>
											</div>

										</div>
									</div>
								</div>
								<div dangerouslySetInnerHTML={{ __html: dashboardContent?.acf?.debrief?.content || "" }} />
								<a className="btn btn-primary w-100" href={dashboardContent?.acf?.debrief?.button_url || "#"}>{dashboardContent?.acf?.debrief?.button_text || "Learn More About Debriefs"}</a>
							</Card>

							{
								dashboardContent?.acf?.additional_cards?.cards?.length
									? dashboardContent?.acf?.additional_cards?.cards.map((card, idx) => (
										<Card body className="bg-eqqo-light-gray mt-4 border-0" key={idx}>
											<div className="d-flex gap-3 align-items-center">
												<Image src={card.image} width="344" />
												<div className="flex-fill">
													<div dangerouslySetInnerHTML={{ __html: card.content }} />
													<Row className="d-flex gap-0 lg-2 md-1 flex-wrap">
														{
															card.buttons.length
																? card.buttons.map((button, buttonIdx) => <Col key={buttonIdx}><Button className="w-100 fs-14" href={button.url}>{button.text}</Button></Col>)
																: null
														}
													</Row>
												</div>
											</div>
										</Card>

									)) : null
							}
						</Card>
					</Col>
				</Row>
				{/* <Row className="mt-2">
					<Col>
						<Container className="bg-white border h-100 rounded-3">
							<Accordion defaultActiveKey="0">
								<Accordion.Item>
									<Accordion.Header as="h2">Explore Journal Prompts</Accordion.Header>
									<Accordion.Body>
										<JournalPrompts />
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Container>
					</Col>
				</Row> */}
				{/* <Row className="mt-2">
					<Col>
						<Container className="bg-white border h-100 rounded-3">
							<h2>Frequently Asked Questions</h2>
							<dl className="faqs mt-4">
								{faqs.map(({ question, answer, number }) => (
									<div key={`faq_${number}`}>
										<dt>{question}</dt>
										<dd dangerouslySetInnerHTML={{ __html: answer }} />
									</div>
								))}
							</dl>
							<p className="alert alert-info mb-0 mt-5 text-center">If you still have questions or need help with anything, please email <a href="mailto:support@EQQOProfile.com">support@EQQOProfile.com</a></p>
						</Container>
					</Col>
				</Row> */}
			</div>
		);
}

export default ProfileCompleteDashboard;